/* @flow */
import styled from 'styled-components';

import { Table } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

export const StatTable = styled(Table).attrs({ borderRadius: [8, 8, 15] })(
  css({
    width: '100%',
    fontSize: [13, 13, 20],
    color: 'gray100',

    // iPhone SE
    '@media screen and (max-width: 360px)': {
      fontSize: 12,
    },

    tbody: {
      bg: 'white',
    },

    'th, td': {
      fontWeight: 'normal',
      lineHeight: 'title',
    },
  })
);
